<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001853')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<find-search ref="searchView" :scrId="scrId" @Refresh="refresh"></find-search>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<find-table ref="tableView" :scrId="scrId" @SelectRow="sendParam" @Refresh="refresh"></find-table>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import FindSearch from './FindSearch.vue';
import FindTable from './FindTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: false
		};
	},
	components: { FindSearch, FindTable },
	methods: {
		...rootMethods,
		...serviceMethods,
		async open() {
			this.$sf_toggleLoading(true);
			this.isLoaded = false;
			this.show = true;
			this.setFindPopupInit_();
			try {
				if (this.isPqyGuest) {
					this.setFindPopupSearchParams_({ key: 'cofCd', value: this.searchParams.cofCd });
					this.setFindPopupSearchParams_({ key: 'cofNm', value: this.searchParams.cofNm });
				}
				this.refresh();
			} catch (error) {
				console.error(error);
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		},
		close() {
			this.setFindPopupInit_();
			this.isLoaded = false;
			this.show = false;
		},
		sendParam(row) {
			this.$emit('SendData', row);
			this.close();
		},
		refresh() {
			this.$refs.searchView?.searchList();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style></style>
